<template>
  <el-dialog
    title="设置阶梯价"
    :visible.sync="setPriceVisible"
    width="600px"
    :before-close="handleClose"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="set-price"
  >
    <div class="set-price-content">
      <div>
        <div style="margin-bottom:10px" class="ex-header">
          <div>
            <span>起订量：</span><span>{{ this.rowObj.minorderquantity }}</span>
          </div>

          <el-popover placement="right" width="600" trigger="hover">
            <el-table
              :data="exPriceData"
              border
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              size="small"
              current-row-key="index"
              class="validate-table"
            >
              <el-table-column label="数量范围" min-width="300">
                <template slot-scope="scope">
                  <span>{{ scope.row.startValue }}</span> ~
                  <span v-if="scope.$index !== 2">{{ scope.row.endValue }}</span>
                </template>
              </el-table-column>
              <el-table-column label="设置价格（元）" min-width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.price }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 10px;">
              <p>数量大于等于10, 小于200, 价格为10元</p>
              <p>数量大于等于200, 小于500, 价格为8元</p>
              <p>数量大于等于500, 价格为5元</p>
            </div>
            <el-button class="my-btn" slot="reference">?</el-button>
          </el-popover>
        </div>
        <div>
          <!--查看 -->
          <el-table
            v-if="ifEdit"
            :data="setPriceData"
            border
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
            size="small"
            current-row-key="index"
            class="validate-table"
          >
            <el-table-column label="数量范围" min-width="300">
              <template slot-scope="scope">
                <span>{{ scope.row.startValue }}</span> ~
                <span v-if="scope.$index !== 2">{{ scope.row.endValue }}</span>
              </template>
            </el-table-column>
            <el-table-column label="设置价格（元）" min-width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.price }}</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 新增/编辑 -->
          <el-table
            v-else
            :data="setPriceData"
            border
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
            size="small"
            current-row-key="index"
            class="validate-table"
          >
            <el-table-column label="数量范围" width="359px">
              <template slot-scope="scope">
                <el-input-number
                  :min="0"
                  :disabled="scope.$index === 0 || scope.$index === 1 || scope.$index === 2"
                  style="width: 130px;"
                  v-model.number="scope.row.startValue"
                  type="number"
                  :controls="false"
                ></el-input-number>
                ~
                <el-input-number
                  :min="0"
                  v-if="scope.$index !== 2"
                  style="width: 130px;"
                  v-model.number="scope.row.endValue"
                  type="number"
                  :controls="false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="设置价格（元）" width="200px">
              <template slot-scope="scope">
                <el-input-number
                  :min="1"
                  v-model.number="scope.row.price"
                  type="number"
                  :controls="false"
                ></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button :loading="btnLoading" type="primary" @click="setData" v-if="!ifEdit">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from "../../../api/product";
export default {
  props: {
    setPriceVisible: {
      type: Boolean,
      default: false,
    },
    rowObj: {
      type: Object,
      default() {
        return {};
      },
    },
    ifEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      setPriceData: [
        {
          endValue: 0,
          price: 0,
          startValue: this.rowObj.minorderquantity,
        },
        {
          endValue: 0,
          price: 0,
          startValue: 0,
        },
        {
          endValue: 0,
          price: 0,
          startValue: 0,
        },
      ],
      btnLoading: false,
      exPriceData: [
        {
          endValue: 200,
          price: 10,
          startValue: 10,
        },
        {
          endValue: 500,
          price: 8,
          startValue: 200,
        },
        {
          endValue: 0,
          price: 5,
          startValue: 500,
        },
      ],
    };
  },
  watch: {
    setPriceVisible(newVal) {
      if (newVal) {
        this.getPrice();
      }
    },
    setPriceData: {
      handler(newVal) {
        newVal.forEach(item => {
          if (item.startValue < 0) {
            item.startValue = 0;
          }
          if (item.endValue < 0) {
            item.endValue = 0;
          }
          if (item.price < 0) {
            item.price = 0;
          }
        });
        if (newVal) {
          if (newVal[0].endValue > 0) {
            this.setPriceData[1].startValue = newVal[0].endValue;
          }
          if (newVal[1].endValue > 0) {
            this.setPriceData[2].startValue = newVal[1].endValue;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    async getPrice() {
      const res = await api.queryStepPrice({
        skuId: this.rowObj.skuid,
        supplierCompanyId: this.rowObj.suppliercompanyid,
      });
      if (res.code === "200") {
        // true 新增, false 查看
        this.setPriceFlag = res.data.length === 0;
        if (res.data.length === 0) {
          this.setPriceData = [
            {
              endValue: 0,
              price: this.rowObj.price,
              startValue: this.rowObj.minorderquantity,
            },
            {
              endValue: 0,
              price: 0,
              startValue: 0,
            },
            {
              endValue: 0,
              price: 0,
              startValue: 0,
            },
          ];
        } else {
          this.setPriceData = [...res.data];
        }
      }
    },
    refreshList() {
      this.$emit("refreshList");
    },
    handleClose() {
      this.$emit("update:setPriceVisible", false);
    },
    // 新增
    async addPrice(params) {
      this.btnLoading = true;
      const res = await api.addStepPrice(params);
      this.btnLoading = false;
      if (res.code === "200") {
        this.$message.success("您的阶梯价已设置成功");
        this.handleClose();
        this.refreshList();
      }
    },
    // 修改
    async modificationPrice(params) {
      this.btnLoading = true;
      const res = await api.modifyStepPrice(params);
      this.btnLoading = false;
      if (res.code === "200") {
        this.$message.success("您的阶梯价已设置成功");
        this.handleClose();
        this.refreshList();
      }
    },
    async setData() {
      console.log("发送的数据前:", this.setPriceData);
      let flag = 0;
      this.setPriceData.forEach((item, index) => {
        if (index === 2) {
          item.endValue = 99999;
        }
        if (item.startValue < 0 || !item.endValue < 0) {
          flag = 1;
        }
        if (item.price < 0) {
          flag = 2;
        }
      });
      if (flag === 1) {
        this.$message.warning("请设置正确的阶梯数量。");
        return;
      } else if (flag === 2) {
        this.$message.warning("请设置正确的价格。");
        return;
      }

      if (
        this.setPriceData[0].startValue > this.setPriceData[0].endValue ||
        this.setPriceData[1].startValue - this.setPriceData[0].endValue !== 0 ||
        this.setPriceData[1].startValue >= this.setPriceData[1].endValue ||
        this.setPriceData[2].startValue - this.setPriceData[1].endValue !== 0
      ) {
        this.$message.warning("您好，您设置的阶梯价不连续，请重新输入。");
        return;
      }
      delete this.setPriceData[2].endValue;
      const { skuid: skuId, suppliercompanyid: supplierCompanyId } = this.rowObj;
      const params = { skuId, supplierCompanyId, stepPriceAddAOList: this.setPriceData };
      if (this.setPriceFlag) {
        this.addPrice(params);
      } else {
        this.modificationPrice(params);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.set-price {
  .ex-header {
    display: flex;
    justify-content: space-between;
    ::v-deep .my-btn {
      width: 28px;
      height: 28px;
      padding: 0;
      border-radius: 100% !important;
      text-align: center;
    }
  }
  .one {
    ::v-deep .el-input-number {
      width: 100px;
    }
  }
}
</style>
